module.exports = __webpack_public_path__ + "static/assets/a7b03ed2406aad7ef315204248127994.jpg";